var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('views',{staticClass:"verify-approval"},[_c('nav-bar',{attrs:{"title":_vm.moduleTitle},on:{"click-left":_vm.onClickLeft}}),_c('views',{staticClass:"verify-approval-img"},[_c('images',{attrs:{"src":_vm.imgUrl}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }